import React from 'react';
import Navigation from './Navigation';

const Header = ({ 
  title = "City Group Apps", 
  navItems, 
  activeTab, 
  onTabChange,
  className = "" 
}) => {
  return (
    <header className={`bg-gray-800 shadow-lg relative ${className}`}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-cyan-400">
            {title}
          </h1>
          
          <Navigation 
            activeTab={activeTab}
            onTabChange={onTabChange}
            navItems={navItems}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;